import { DEVICE_TYPE } from "@constants/index";

export const ACTION = {
    GET_SUBSCRIBER_DEVICE_LIST: 'GET_SUBSCRIBER_DEVICE_LIST',
    DELETE_SUBSCRIBER_DEVICE: 'DELETE_SUBSCRIBER_DEVICE',
};

export const PRIMARY_DEVICES_CHECK = [DEVICE_TYPE.ATV, DEVICE_TYPE.FTV];